import { axios } from "../axios.instance";

export type AdmireUserRequest = {
  userId: string;
};

export type AdmireUserResponse = object;

export const admireUser = async (body: AdmireUserRequest): Promise<AdmireUserResponse> => {
  const { data } = await axios.post(`/admires/${body.userId}/admire`);

  return data;
};
